

















import { computed, defineComponent } from "@vue/composition-api";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatDate, getDurationSymbols } from "@/lib/time";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ContentFeedEventTicket",
  props: {
    contentFeed: { type: Object as () => ContentFeed, required: true },
    isMyEvent: { type: Boolean, required: true },
  },
  components: { BaseAvatar, BaseIcon },
  setup(props) {
    const showTicket = computed(() => props.contentFeed?.type === "event");
    const screenName = computed(() => props.contentFeed?.user.screenName || "");
    const eventIsStarted = computed(
      () =>
        props.contentFeed.details.event &&
        new Date(props.contentFeed.details.event?.time).getTime() <= new Date().getTime()
    );
    const subtitle = computed(() =>
      props.isMyEvent && eventIsStarted.value
        ? $t("Event")
        : props.isMyEvent && !eventIsStarted.value
        ? $t("Upcoming event")
        : $t(`Event by {0}`, [screenName.value])
    );

    const date = computed(() =>
      formatDate(new Date(props.contentFeed?.details.event.time), {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      })
    );

    const durationSymbols = computed(() =>
      getDurationSymbols(Math.floor(props.contentFeed?.details.event.duration * 60 * 1000))
    );

    const duration = computed(() => {
      const h = durationSymbols.value.h;
      const m = durationSymbols.value.m;
      return m !== 0 ? (h === 0 ? `${m}m` : `${h}h ${m}m`) : `${h}h`;
    });

    return {
      date,
      screenName,
      duration,
      showTicket,
      subtitle,
    };
  },
});
